import { render, staticRenderFns } from "./JFilePop.vue?vue&type=template&id=2e4941be&scoped=true&"
import script from "./JFilePop.vue?vue&type=script&lang=js&"
export * from "./JFilePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4941be",
  null
  
)

export default component.exports